import React from 'react';
import styles from './Header.module.css';

const Header: React.FC = () => {
  return (
    <div className={styles.headerWrapper}>
      <header className={styles.header}>
        <div className={styles.container}>
          <a href="https://www.openana.ai" target="_blank" rel="noopener noreferrer" className={styles.logo}>
            <img src="/ANA Logo (1).png" alt="Ana Logo" />
            <img src="/ana_text.svg" alt="Ana" className="h-3 md:h-3 w-auto" />
          </a>
          
          <nav className={styles.nav}>
            <a href="#value" className={styles.navLink}>
              Value
            </a>
            <a href="#personas" className={styles.navLink}>
              Personas
            </a>
            <a href="#enterprise" className={styles.navLink}>
              Enterprise
            </a>
            <a href="#comparison" className={styles.navLink}>
              Comparison
            </a>
            <a 
                href="https://calendly.com/openana" 
                className={styles.ctaButton}
                target="_blank"
                rel="noopener noreferrer">
                Onboard Ana
            </a>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
